<ng-container
  *ngTemplateOutlet="
    planCardTemplate;
    context: {
        cardProps: userPlan,
        generalData: generalData,
        dedicatedData: dedicatedData,
        lowSpeedData: lowSpeedData
       }
  "
></ng-container>

<ng-template
  #planCardTemplate
  let-cardProps="cardProps"
  let-generalData="generalData"
  let-dedicatedData="dedicatedData"
  let-lowSpeedData="lowSpeedData"
>
  <nz-card
    class="end-users-plans-card"
    [nzTitle]="planDisplayNameTemplate"
    [nzExtra]="topMenuTemplate"
  >
    <div class="plan-wrapper">
      <div
        class="plan-prov-title-and-timeline"
        *ngIf="!(cardProps?.isPreprovisioning &&
          cardProps?.status === UserPlanStatus.USERPLAN_PENDING)"
      >
        <ng-container *ngTemplateOutlet="planTimelineTemplate"></ng-container>
      </div>
      <ng-container *ngIf="cardProps?.isPreprovisioning &&
          cardProps?.status === UserPlanStatus.USERPLAN_PENDING">
        <div class="pre-prov-title-text">
          {{ PLANS_PREFIX + "PRE_PROVISIONED_PLAN" | translate }}
        </div>
      </ng-container>
      <hr class="plan-divider" />
      <!--Dedicated data-->
      <app-capacity-info
        [capacityType]="dedicatedData && dedicatedData.length > 0 ? 'icons' : 'noSupport'"
        [capacityTitle]="CREATE_PLAN_MODAL_PREFIX + 'FORM.DEDICATED_DATA.LABEL' | translate"
        [noSupportText]="CREATE_PLAN_MODAL_PREFIX +
                  'FORM.DEDICATED_DATA.NO_DEDICATED_DATA.DESCRIPTION' | translate"
        [hasTooltip]="true"
        [capacityTitleTooltip]="dedDataDesc"
      >
        <div iconsContainer *ngIf="dedicatedData && dedicatedData.length > 0">
          <app-social-v2
            [socialData]="dedicatedData"
            [iconSize]="'medium'"
            [showUsage]="true"
          >
          </app-social-v2>
        </div>
      </app-capacity-info>
      <hr class="plan-divider" />
      <div class="plan-data-wrapper">
        <app-capacity-info
          [capacityTitle]="PLANS_PREFIX + 'GENERAL_DATA' | translate"
          [hasTooltip]="true"
          [isUnlimited]="generalData.hasOwnProperty('unlimited') && generalData.unlimited"
          [capacityTitleTooltip]="CREATE_PLAN_MODAL_PREFIX + 'FORM.GENERAL_DATA.DESCRIPTION' | translate"
          [capacityType]="'data'"
          [capacityPercentage]="generalData.percent"
          [progressBarColor]="userPlan.status === UserPlanStatus.USERPLAN_PENDING
                    ? strokeColorQueued : generalData.percent > 100 ? strokeColorOverCapacity
                    : generalData.hasOwnProperty('unlimited') && generalData.unlimited
                    ? strokeColorUnlimited : strokeColor"
          [progressBarTooltip]="tooltipDataTemplate"
          [capacityData]="generalData.initial
                            | utils: 'convertKibByte'
                            | numberFormatter: '0.0ib'
                            | ibFix"
          [consumedData]="!(generalData.hasOwnProperty('consumed')) ? '0 GB' :
                            (generalData.consumedData
                            | utils: 'convertKibByte'
                            | numberFormatter: '0.0ib'
                            | ibFix)"
        >
        </app-capacity-info>

        <app-capacity-info
          [capacityTitle]="PLANS_PREFIX + 'VOICE' | translate"
          [isUnlimited]="voice.hasOwnProperty('unlimited') && voice.unlimited"
          [capacityTitleTooltip]="CREATE_PLAN_MODAL_PREFIX + 'FORM.GENERAL_DATA.DESCRIPTION' | translate"
          [capacityType]="voice.noSupport ? 'noSupport' : 'voice'"
          [noSupportText]="CREATE_PLAN_MODAL_PREFIX +
                  'FORM.VOICE_CALL.NO_VOICE_CALL.DESCRIPTION' | translate"
          [capacityPercentage]="voice.percent"
          [capacityData]="CREATE_PLAN_MODAL_PREFIX + 'FORM.VOICE_CALL.MINS_COUNT' | translate:
                        {value: voice.initial | utils: 'convertSecToMin'}"
          [consumedData]="CREATE_PLAN_MODAL_PREFIX + 'FORM.VOICE_CALL.MINS_COUNT' | translate:
                        {value: (voice.initial - voice.remaining) | utils: 'convertSecToMin'}"
          [progressBarColor]="userPlan.status === UserPlanStatus.USERPLAN_PENDING || voice.percent > 100
                    ? strokeColorQueued
                    : strokeColor"
          [progressBarTooltip]="tooltipVoiceTemplate"
        ></app-capacity-info>

        <app-capacity-info
          [capacityTitle]="PLANS_PREFIX + 'SMS' | translate"
          [isUnlimited]="sms.hasOwnProperty('unlimited') && sms.unlimited"
          [capacityTitleTooltip]="CREATE_PLAN_MODAL_PREFIX + 'FORM.GENERAL_DATA.DESCRIPTION' | translate"
          [capacityType]="sms.noSupport ? 'noSupport' : 'sms'"
          [noSupportText]="CREATE_PLAN_MODAL_PREFIX +
                  'FORM.SMS.NO_SMS_MESSAGES.DESCRIPTION' | translate"
          [capacityPercentage]="sms.percent"
          [capacityData]="sms.initial && sms.initial.toString()"
          [consumedData]="sms.consumed ? sms.consumed.toString() : (sms.initial - sms.remaining).toString()"
          [progressBarColor]="userPlan.status === UserPlanStatus.USERPLAN_PENDING || sms.percent > 100
                    ? strokeColorQueued
                    : strokeColor"
          [progressBarTooltip]="tooltipSmsTemplate"
        ></app-capacity-info>
      </div>
      <hr class="plan-divider" />
      <app-capacity-info
        [capacityType]="lowSpeedData && lowSpeedData.length > 0 ? 'icons' : 'noSupport'"
        [capacityTitle]="CREATE_PLAN_MODAL_PREFIX + 'FORM.LOW_SPEED_DATA.LABEL' | translate"
        [hasTooltip]="true"
        [noSupportText]="CREATE_PLAN_MODAL_PREFIX +
                  'FORM.LOW_SPEED_DATA.NO_LOW_SPEED_DATA.DESCRIPTION' | translate"
        [capacityTitleTooltip]="lowDataDesc"
      >
        <div iconsContainer>
          <div *ngIf="lowSpeedData && lowSpeedData.length > 0">
            <app-social-v2
              [socialData]="lowSpeedData"
              [showUsage]="true"
              [iconSize]="'medium'">
            </app-social-v2>
          </div>
        </div>
      </app-capacity-info>

      <div class="details-button" nz-row nzAlign="middle" nzJustify="center">
        <button nz-button nzType="primary" nzGhost
                (click)="viewPlanDetails(
                {
                  userPlan: userPlan,
                  generalData: generalData,
                  dedicatedData: dedicatedData,
                  lowSpeedData: lowSpeedData,
                  voice: voice,
                  sms: sms
                 })">
          {{ DATABACK_PREFIX + 'COMMON.DETAILS.TITLE' | translate }}
        </button>
      </div>
    </div>
  </nz-card>

  <ng-template #planDisplayNameTemplate>
    <div class="plan-display-name-class-wrapper" nz-row nzAlign="middle">
      <span class="plan-name">
        {{ cardProps.planDisplayName }}
      </span>
      <ng-container *ngIf="cardProps.planClass">
        <nz-tag>
          {{ PLANS_PREFIX + "PLAN_CLASS." + cardProps.planClass | translate }}
        </nz-tag>
      </ng-container>
      <ng-container *appAccessCtrl="resList.subscriptionsView">
          <span
            class="subscription-details"
            *ngIf="cardProps?.subscriptionId"
            [nzTooltipTitle]="PLANS_PREFIX + 'SUBSCRIPTION.CREATED_BY_SUBSCRIPTION' | translate"
            nzTooltipPlacement="top"
            nz-tooltip
          >
           <span *ngIf="activeSubscription?.subscriptionStatus === SubscriptionStatus.SUBSCRIPTION_PAUSED;
            else subsciptionNormal">
             <i [ngStyle]="{ 'color': strokeColorSubscriptionPaused }" class="far fa-sync-alt"></i>
           </span>
          </span>
        <ng-template #subsciptionNormal>
          <i *ngIf="userPlan.subscriptionId &&
              userPlan.subscriptionId === activeSubscription?.subscriptionId; else subsciptionNoClick"
             class="far fa-sync-alt"
             (click)="viewSubscription()"
          ></i>
        </ng-template>
        <ng-template #subsciptionNoClick>
          <i class="far fa-sync-alt"></i>
        </ng-template>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #planTimelineTemplate>
    <ng-container *ngIf="userPlan.status === UserPlanStatus.USERPLAN_ACTIVE">
      <div class="plan-timeline-text">
        {{ PLANS_PREFIX + "ACTIVATED" | translate }}:
        <span>{{ cardProps.activatedTs | localizedDate: formatDate }}</span>
      </div>
      <div class="plan-timeline-text">
        {{ PLANS_PREFIX + "ENDS" | translate }}:
        <span>{{ cardProps.expirationTs | localizedDate: formatDate }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="userPlan.status === UserPlanStatus.USERPLAN_PENDING">
      <div class="plan-timeline-text">
        {{ PLANS_PREFIX + "QUEUED" | translate }}:
        <span>{{ cardProps.statusUpdateTs | localizedDate: formatDate }}</span>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #tooltipDataTemplate>
    {{
      !(generalData.hasOwnProperty('remaining')) ? '0 Gb' :
        generalData.remaining
          | utils: "convertKibByte"
          | numberFormatter: "'0.0ib'"
          | ibFix
    }}
    {{ GROUPS_MECTRIC_USAGE_PREFIX + "DATA_REMAINING" | translate }}
  </ng-template>

</ng-template>

<ng-template #topMenuTemplate>
  <app-copy-text
    *ngIf="userPlan.userPlanId"
    [textToCopy]="userPlan.userPlanId"
    [customCopyTooltipText]="PLANS_PREFIX + 'PLANS.PLAN_DROPDOWN.COPY_USER_PLAN_ID' | translate"
  ></app-copy-text>
</ng-template>

<ng-template #tooltipVoiceTemplate>
  {{
  CREATE_PLAN_MODAL_PREFIX + 'FORM.VOICE_CALL.MINS_COUNT' | translate:
    {value: voice.remaining
        | utils: 'convertSecToMin'}
  }}
  {{ GROUPS_MECTRIC_USAGE_PREFIX + "REMAINING" | translate }}
</ng-template>

<ng-template #tooltipSmsTemplate>
  {{ sms.remaining }}
  {{ GROUPS_MECTRIC_USAGE_PREFIX + "SMS_REMAINING" | translate }}
</ng-template>

<ng-template #dedDataDesc>
  <span [innerHTML]="CREATE_PLAN_MODAL_PREFIX + 'FORM.DEDICATED_DATA.SHORT_DESCRIPTION' | translate"></span>
</ng-template>

<ng-template #lowDataDesc>
  <span [innerHTML]="CREATE_PLAN_MODAL_PREFIX + 'FORM.LOW_SPEED_DATA.SHORT_DESCRIPTION' | translate"></span>
</ng-template>
